/*jshint esversion: 6 */

(function () {
    'use strict';
    $(function () {

        //Clicked outside of element
        window.clickedOutside = function (targetToClose, callback, _excludes = []) {
            const excludes = Array.isArray(_excludes) ? _excludes : [_excludes];
            const $target = $(targetToClose);

            if (typeof callback !== "function") {
                console.error('Callback has to be a function!');
                return null;
            }

            $('body').on('click', function (e) {
                const clickedElement = e.target;
                const isTargetVisible = $target.css('display') !== 'none';
                const isClickedElementExcluded = excludes.some((exclusion) => $(exclusion).is(clickedElement) || !!$(exclusion).has(clickedElement).length);
                const isClickedElementTarget = $target.is(clickedElement);
                const isClickedElementATargetChild = $target.has(clickedElement).length === 0;

                if (
                    isTargetVisible &&
                    !isClickedElementExcluded &&
                    !isClickedElementTarget &&
                    isClickedElementATargetChild
                ) {
                    callback($target, excludes);
                }
            });
        }

        clickedOutside('#theme-box .dropdown-box-list', function() {
                $('#theme-box .dropdown-box-list').slideUp();
        }, ['#theme-box .dropdown-box-toggle']);

        clickedOutside('#industry-box .dropdown-box-list', function() {
            $('#industry-box .dropdown-box-list').slideUp();
        }, ['#industry-box .dropdown-box-toggle']);

        clickedOutside('.select-box .select-container', function() {
            $('.select-box .select-container').fadeOut();
        }, ['.select-box .overSelect']);

        window.callAjax = function (data, complete) {
            $.ajax({
                type: "post",
                dataType: "json",
                url: "/data-processor.php",
                data: data,
                complete: complete,
                error: function (err) {
                    console.log(err);
                }
            });
        }

        $(document).ready(function () {

            $('a[href^="#"]').click(function (e) {
                var target = this.hash;
                if (target) {
                    var $target = $(target);
                    $('html, body').stop().animate({
                        'scrollTop': $target.offset().top
                    }, 900, 'swing', function () {
                        //window.location.hash = target;
                    });
                }
            });

            $(".download-report-button").click(function () {
                fbq('track', 'Lead');
            });

            $('.prettySocial').prettySocial();
            $('.linkedinSocial').linkedinSocial();

            const $filter = $('main.subpage #content .filter');
            $(window).on('resize', function () {
                $filter.css('display', '');
            });

            $('.toggle-mobile-filters').on('click', function () {
                $filter.stop().slideToggle();
            });

            $('main.front-page section.index .link-arrow').on('click', function (e) {
                e.preventDefault();
                $(this).fadeOut();
                $(this).parent().find('.hidden-content').slideDown();
            })

        });
        
    });
}(jQuery));
